// src/lib/recentSearches.ts
// localStorage-backed CRUD for the user's recent search queries on /price-check.
// Pure module: no React, no zustand. The UI calls these functions and drives its
// own state from the returned arrays.

const STORAGE_KEY = 'spent-tracker:recentSearches';
const MAX_ENTRIES = 6;

function read(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((x): x is string => typeof x === 'string');
  } catch {
    return [];
  }
}

function write(items: string[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  } catch {
    // Storage may be unavailable (private browsing, quota); silently no-op.
  }
}

export function getRecentSearches(): string[] {
  return read();
}

export function pushRecentSearch(query: string): string[] {
  const trimmed = query.trim();
  if (!trimmed) return read();
  const lower = trimmed.toLowerCase();
  const existing = read();
  const filtered = existing.filter((q) => q.toLowerCase() !== lower);
  const next = [trimmed, ...filtered].slice(0, MAX_ENTRIES);
  write(next);
  return next;
}

export function removeRecentSearch(query: string): string[] {
  const lower = query.toLowerCase();
  const existing = read();
  const next = existing.filter((q) => q.toLowerCase() !== lower);
  write(next);
  return next;
}

export function clearRecentSearches(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
